<template>
  <!-- 抽屉，弹出批次管理设备的详情 -->
  <el-drawer
        :append-to-body="true"
        class="drawer"
        size="50%"
        :withHeader="true"
        show-close
          title="绑定任务详情"
          :visible.sync="showDetailView.show">
          <div class="detailContent cgray-01">
            <div class="flex1">
              <el-row class="title">
                <el-col>CA证书名称：<span>{{certName}}</span></el-col>
              </el-row>
              <el-row :span="24" class="cgray-02 fs10">
                <el-col :span="12">绑定时间：<span>{{detail.bindTime}}</span></el-col>
                <el-col :span="12">绑定数量：<span>{{detail.bindNum}}</span></el-col>
              </el-row>
            </div>
            <!-- <div>
              <el-button>下载CSV</el-button>
            </div> -->
          </div>
          <div class="flex1">

            <div class="showDataView2">
              <el-table
                border
                height="100%"
                :data="detailList"
                tooltip-effect="dark"
                style="width: 100%">
                <template slot="empty">
                  <emptyView></emptyView>
                </template>
                <el-table-column
                  prop="devCertSn"
                  label="设备证书SN">
                </el-table-column>
                <el-table-column
                  prop="productKey"
                  label="productKey">
                </el-table-column>
                <el-table-column
                 prop="deviceName"
                  label="deviceName">
                </el-table-column>
              </el-table>
            </div>

          </div>
         <el-row class="footer" :span="24">
           <el-col :span="8">
              <el-button @click="closeView" type="primary" size="small">确 定</el-button>
              <el-button @click="closeView" size="small">关 闭</el-button>
           </el-col>
           <el-col :span="16">

             <Paging
              :total="pageParams.total"
              pagingStatus="short"
              @changePage="currentPageChange"/>

           </el-col>
          </el-row>
        </el-drawer>
</template>
<script>
// import emptyView from '@/components/empty_view/empty'
import Paging from '@/components/paging'
export default {
  components: {
    // emptyView
    Paging
  },
  props: {
    showDetailView: {
      type: Object
    },
    detailList: {
      type: Array
    },
    certName: {
      type: String
    },
    detail: {
      type: Object
    },
    pageParams: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    closeView () {
      this.$emit('close-view')
    },
    currentPageChange (listQuery) {
      // this.pageParams.pageNumber = num
      this.$emit('current-page-change', listQuery)
      // this.linkDetail()
    }
  },
  watch: {
    detailList () {
      console.log('变化了')
    }
  }
}
</script>
<style lang="less" scope>
.drawer{
    overflow-y: auto;
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    .detailContent{
      display: flex;
      background-color: #fbfbfc;
      border: 1px solid #ecedee;
      padding: 20px;
      .flex1{
        flex:auto;

      }
    }
    .flex1{
      flex:auto;
      position: relative;
      margin-top: 20px;
      .el-row{
        margin-top: 10px;
      }
      .title{
        font-size: 18px;
      }
    }
    .cgray-01{
      color: rgb(51, 51, 51)
    }
    .cgray-02{
      color: rgb(85, 85, 85)
    }
    .fs10{
      font-size: 10px;
    }
    .footer{
      padding: 20px 10px ;
    }
    .el-drawer__body{
      margin: 10px 20px;
      display: flex;
      flex-direction: column;
    }
    .dataListOperation{
      display: flex;
      flex-wrap: nowrap;
      white-space: nowrap;
      align-items: center;
    }
    .showAll{
      line-height: 32px;
    }
    .drawer-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        margin-top: 10px;
        padding: 0 24px ;
        height:64px;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
  }
</style>
